import { render, staticRenderFns } from "./FeedFuture-Criar.vue?vue&type=template&id=d5fd5486&"
import script from "./FeedFuture-Criar.vue?vue&type=script&lang=js&"
export * from "./FeedFuture-Criar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports